<template>
  <div v-if="$can('customers.manage')">
    <div class="col-md-12 card">
      <div class="card-content row">
        <div class="col-sm-6 col-md-9"></div>
        <div class="col-sm-6 col-md-3"><p-search @on-search="handleSearch($event)" /></div>

        <div class="col-sm-12">
          <el-table class="table-striped" :data="tableData" :default-sort="{prop: 'createdAt', order: 'descending'}" @sort-change="handleSort($event)" v-loading="loading" style="width: 100%">
            <el-table-column prop="uc" label="UC">
              <template slot-scope="scope">
                <a @click="handleCustomerDetail(scope.row._id)">
                  {{ scope.row.uc }}
                </a>
              </template>
            </el-table-column>

            <el-table-column prop="holder" label="Nome" sortable="custom" />

            <el-table-column prop="cpf" label="CPF" />

            <el-table-column prop="createdAt" label="Criado Em" sortable="custom">
              <template slot-scope="scope">
                {{ new Date(scope.row.createdAt) | moment('DD/MM/YYYY HH:mm:ss') }}
              </template>
            </el-table-column>

            <el-table-column :min-width="100" fixed="right" label="">
              <template slot-scope="props">
                <div class="text-right">
                  <a @click="handleCustomerDetail(props.row._id)" v-if="$can('customer.detail')" class="btn btn-icon btn-fill btn-primary remove" title="Detalhes do cliente"><i class="ti-user"></i></a>

                  <router-link :to="{name: 'customers.tickets', params: {id: props.row._id}}"><a v-if="$can('customers.tickets')" class="btn btn-icon btn-fill btn-primary remove" title="Gerenciar Tickets"><i class="ti-ticket"></i></a></router-link>

                  <router-link :to="{name: 'customers.lamps', params: {id: props.row._id}}"><a v-if="$can('customers.lamps')" class="btn btn-icon btn-fill btn-success" title="Trocar lâmpadas"><i class="ti-light-bulb"></i></a></router-link>

                  <router-link :to="{name: 'customers.edit', params: {id: props.row._id}}"><a v-if="$can('customers.edit')" class="btn btn-primary btn-fill btn-icon edit" title="Editar cliente"><i class="ti-pencil-alt"></i></a></router-link>

                  <a v-if="$can('customers.remove')" class="btn btn-danger btn-fill btn-icon remove" @click="handleDelete(props.$index, props.row)" title="Deletar cliente"><i class="ti-trash"></i></a>

                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="col-sm-12 text-center">
          <p-pagination v-if="!searched" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total"></p-pagination>
        </div>

      </div>
    </div>

    <div class="col-sm-12 pagination-info text-right">
      <p class="category"> Mostrando de {{from + 1}} até {{to}} de {{total}} no total. </p>
    </div>


  </div>
</template>
<script>
import { Option, Select, Table, TableColumn } from 'element-ui'
import Couchdb from 'src/services/Couchdb'
import PSearch from 'src/components/UIComponents/Inputs/Search.vue'
import PPagination from 'src/components/UIComponents/Pagination.vue'
import swal from 'sweetalert2'
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Select)
Vue.use(Option)

export default {
  components: {
    PPagination,
    PSearch
  },

  data () {
    return {
      pagination: {
        perPage: 25,
        currentPage: 1,
        total: 0
      },
      sort: {},
      searched: false,
      search: {
        query: '',
        fields: ['uc', 'holder', 'cpf', 'createdAt', '_id']
      },
      count: 0,
      page: 1
    }
  },

  computed: {
    ...mapGetters('customers', {
      tableData: 'customers',
      loading: 'loading'
    }),

    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },
    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },
    total () {
      this.pagination.total = this.searched ? this.tableData.length : this.count
      return this.searched ? this.tableData.length : this.count
    },
    currentPage () {
      return this.pagination.currentPage
    }
  },

  watch: {
    currentPage () {
      if (this.search.query && this.search.query !== '') {
        this.handleSearch(this.search.query)
      } else {
        this.fetch()
      }
    }
  },

  methods: {
    ...mapActions('customers', ['fetchAll', 'fetchViewAll', 'delete', 'fetchOne', 'resetOne', 'searchCustomer']),
    ...mapActions('tickets', {
      resetTickets: 'resetAll'
    }),
    ...mapActions('lamps', {
      resetLamps: 'resetAll'
    }),
    fetch () {
      this.searched = false
      this.fetchAll({
        'limit': this.pagination.perPage,
        'skip': this.from,
        'sort': this.sort,
        'select': this.search.fields
      })
      this.counter()
    },

    handleSearch (query) {
      if (query.trim() === '') {
        this.searched = false
        this.$nextTick(() => {
          this.fetch()
        })
      }
      this.search.query = query
      let limit = Math.floor(this.pagination.perPage / 3)
      let skip = limit * (this.pagination.currentPage - 1)
      this.searched = true
      this.searchCustomer({
        query,
        options: {limit, skip}
      })
    },

    handleSort (sort) {
      this.sort = {
        field: sort.prop,
        direction: sort.order
      }
      this.fetch()
    },

    handleDelete (index, row) {
      swal({
        title: 'Você tem certeza?',
        text: `Não será possível reverter essa ação!`,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Sim, pode deletar!',
        buttonsStyling: false
      })
      .then(() => {
        this.delete(row._id)
        .then(() => {
          this.$notify({
            message: 'Registro deletado com sucesso.',
            type: 'success'
          })
          this.fetch()
        })
        .catch(err => console.log(err))
      })
    },

    handleCustomerDetail (customerId) {
      this.resetOne()
      this.resetTickets()
      this.resetLamps()
      this.$router.push({ name: 'customer.detail', params: { id: customerId } })
    },

    counter () {
      Couchdb.view('count-customers-all', 'count-customers-all')
        .then(result => {
          this.count = result.rows[0].value
        })
    }
  },

  mounted () {
    this.searched = false
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Customers/CustomersIndex.vue